module.exports = __webpack_public_path__ + "static/media/ils-share-report.427238b4.svg";